import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const November = () => {
    return (
        <Fragment>{SkipDays(7, 1, [], true)}</Fragment>  
    )
}